const faCreateFile: Record<string, { message: string; description: string }> = {
  "ledgerEditor.nameYourFile": {
    message: "نام فایل را وارد کنید...",
    description: "Placeholder for file name input",
  },
};

export default faCreateFile;
